import React,{ Component } from 'react';
import { connect }  from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '../../components/Loader';
import ServiceRequestTable from '../../components/ServiceRequestsTable';
import { clearSearch, setSearch } from '../../store/actions/search';
import { fetchServiceRequestByCommonAreaIdUserIdRole } from '../../store/actions/serviceRequests';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectLoader } from '../../store/selectors/loader';
import { selectServiceRequests } from '../../store/selectors/serviceRequests';
import { PATHS } from '../../common/constants';
import { fetchCommonAreaServiceRequestCSVExportDownloadList } from '../../store/actions/csvExport';


class CommonAreaServiceRequests extends Component {
    state = {
        searchString: ''
      }
    componentDidMount(){
        const { commonArea,fetchServiceRequestByCommonAreaIdUserIdRole,clearSearch,user } = this.props;
        fetchServiceRequestByCommonAreaIdUserIdRole(commonArea.id,user.roles[0].role.name, 1, '')
        clearSearch()
    }
    loadMoreServiceRequest = async () => {
        const { fetchServiceRequestByCommonAreaIdUserIdRole, paginationCount, commonArea,user } = this.props;
        fetchServiceRequestByCommonAreaIdUserIdRole(commonArea.id,user.roles[0].role.name, paginationCount+1, this.state.searchString)
      }
      search = async (text) => {
        this.setState({ searchString: text})
        const { fetchServiceRequestByCommonAreaIdUserIdRole, commonArea,user } = this.props;
          fetchServiceRequestByCommonAreaIdUserIdRole(commonArea.id,user.roles[0].role.name, 1, text, true)
      }

      downloadCSV(){
        const { fetchCommonAreaServiceRequestCSVExportDownloadList,user,commonArea } = this.props;
        fetchCommonAreaServiceRequestCSVExportDownloadList(commonArea.id,user.roles[0].role.name, this.state.searchString);
      }
      
    render(){
        const { commonArea,property,serviceRequests,loader,setSearch} = this.props;
        return(
            loader ? <Loader /> :
            <ServiceRequestTable
                download= {() => this.downloadCSV()}
                serviceRequest={serviceRequests}
                // onSearch={ e => setSearch({serviceRequests:e.target.value})}
                onSearch = {e => this.search(e.target.value.trim())}
                serviceRequest={{ CommonAreaId:commonArea.id,property_id: property.id,propertyId:property.id,IsServiceRequest:'CommonArea', serviceRequestType: 'Common Area'}}
                loadServiceRequest = {this.loadMoreServiceRequest}
                from='CommonArea'
                navigateTo={PATHS.COMMON_AREA_VIEW.replace(':id', commonArea.id+'&'+property.id)}
            />
        );
    }
}

const mapStateToProps = state => ({
    paginationCount: state.paginationCount.count,
    pageCount: state.serviceRequestStatusPageCount.pageCount,
    serviceRequests:selectServiceRequests(state),
    user:selectAuthenticatedUser(state),
    loader:selectLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchServiceRequestByCommonAreaIdUserIdRole:fetchServiceRequestByCommonAreaIdUserIdRole,
    setSearch:setSearch,
    clearSearch:clearSearch,
    fetchCommonAreaServiceRequestCSVExportDownloadList:fetchCommonAreaServiceRequestCSVExportDownloadList
},dispatch);

export default  connect(mapStateToProps,mapDispatchToProps)(CommonAreaServiceRequests);